/**
 * FAQ — нумерованный editorial-аккордеон.
 */
import { Plus } from "lucide-react";
import { useLang } from "../i18n";
import { useReveal } from "../lib/motion";
import { SectionHead } from "./SectionHead";

export function FAQ() {
  const { t } = useLang();
  const ref = useReveal<HTMLElement>();

  return (
    <section
      id="faq"
      ref={ref}
      className="relative border-t"
      style={{ borderColor: "var(--line)", background: "var(--bg-deep)" }}
    >
      <div
        className="mx-auto w-full max-w-5xl px-5 sm:px-8"
        style={{ paddingTop: "var(--space-section)", paddingBottom: "var(--space-section)" }}
      >
        <SectionHead
          num="08"
          label={t.faq.label}
          title={t.faq.title}
          accent={t.faq.accent}
        />

        <div className="border-t" style={{ borderColor: "var(--line)" }}>
          {t.faq.items.map((item, i) => (
            <details
              key={i}
              className="acc reveal border-b"
              data-reveal=""
              style={{
                borderColor: "var(--line)",
                "--reveal-delay": `${i * 60}ms`,
              } as React.CSSProperties}
            >
              <summary className="flex items-center gap-5 py-6">
                <span className="t-brand w-9 flex-shrink-0 text-sm" style={{ color: "var(--gold)" }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1 text-lg font-bold sm:text-xl" style={{ color: "var(--fg)" }}>
                  {item.q}
                </span>
                <span
                  className="acc-icon flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border"
                  style={{ borderColor: "var(--line-strong)", color: "var(--fg-soft)" }}
                >
                  <Plus className="h-4 w-4" aria-hidden />
                </span>
              </summary>
              <div className="acc-body">
                <div>
                  <p
                    className="max-w-3xl pb-7 pl-[56px] pr-4 text-base leading-relaxed"
                    style={{ color: "var(--fg-soft)" }}
                  >
                    {item.a}
                  </p>
                </div>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
